import React, { useEffect, useState } from "react";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { CardLayout } from "../CustomSubtopicCardLayout";
import { PriceLayoutRow } from "./PriceLayoutRow";
export const PriceLayoutCard = ({ title, subtitle, tooltip, initialSubtopics, baseCount, maxSubtopics, onAddedCountChange, onSubtopicsChange, saveTrigger, onEditingCountChange, readOnly, hasBeenRun, }) => {
    const analytics = useAnalytics();
    const defaultCount = baseCount !== null && baseCount !== void 0 ? baseCount : initialSubtopics.length;
    const [subtopics, setSubtopics] = useState(initialSubtopics);
    const addedCount = subtopics.length - defaultCount;
    useEffect(() => {
        onAddedCountChange === null || onAddedCountChange === void 0 ? void 0 : onAddedCountChange(addedCount);
    }, [addedCount, onAddedCountChange]);
    useEffect(() => {
        onSubtopicsChange === null || onSubtopicsChange === void 0 ? void 0 : onSubtopicsChange(subtopics);
    }, [subtopics, onSubtopicsChange]);
    const handleEdit = (index, newValue) => {
        const isDefault = index < defaultCount;
        if (!newValue && isDefault) {
            return;
        }
        analytics.track("Custom Subtopics | Subtopic Edited", { category: title, index, newValue });
        setSubtopics((prev) => prev.map((item, i) => (i === index ? newValue : item)));
    };
    return (React.createElement(CardLayout, { title: title, subtitle: subtitle, tooltip: tooltip, canAddMore: false, maxSubtopics: maxSubtopics, readOnly: readOnly, hasBeenRun: hasBeenRun, hideAddButton: true },
        React.createElement(PriceLayoutRow, { subtopics: subtopics, defaultCount: defaultCount, onEdit: handleEdit, category: title, saveTrigger: saveTrigger, onEditingCountChange: onEditingCountChange, readOnly: readOnly, hasBeenRun: hasBeenRun })));
};
